import React, { useState, useEffect, useCallback } from "react";

import img1 from "../../Assets/levdc/banner1.webp";
import img2 from "../../Assets/levdc/banner2.webp";
import img3 from "../../Assets/levdc/banner3.webp";
import tabletimg1 from '../../Assets/levdc/tabletbanner1.webp';
import tabletimg2 from '../../Assets/levdc/tabletbanner2.webp';
import tabletimg3 from '../../Assets/levdc/tabletbanner3.webp';
import mobileImg1 from "../../Assets/levdc/mobilebanner1.webp";
import mobileImg2 from "../../Assets/levdc/mobilebanner2.webp";
import mobileImg3 from "../../Assets/levdc/mobilebanner3.webp";

const BANNER_SLIDES = [
  {
    desktop: img1,
    tablet: tabletimg1,
    mobile: mobileImg1,
    eyebrow: "Now Launching",
    title: ["Keep Light EVs ", "in Motion"],
    sub: "Purpose-built DC fast charging for India's 2-wheeler and 3-wheeler EV fleet — compact, smart, and made for high-frequency turnarounds.",
    primaryLabel: "Contact Us",
    primaryHref: "/get-in-touch#contact-us",
    secondaryLabel: "View Specifications",
    secondaryHref: "#specs",
  },
  {
    desktop: img2,
    tablet: tabletimg2,
    mobile: mobileImg2,
    eyebrow: "Now Launching",
    title: ["Keep Light EVs ", "in Motion"],
    sub: "Purpose-built DC fast charging for India's 2-wheeler and 3-wheeler EV fleet — compact, smart, and made for high-frequency turnarounds.",
    primaryLabel: "Contact Us",
    primaryHref: "/get-in-touch#contact-us",
    secondaryLabel: "View Specifications",
    secondaryHref: "#specs",
  },
  {
    desktop: img3,
    tablet: tabletimg3,
    mobile: mobileImg3,
    eyebrow: "Now Launching",
    title: ["Keep Light EVs ", "in Motion"],
    sub: "Purpose-built DC fast charging for India's 2-wheeler and 3-wheeler EV fleet — compact, smart, and made for high-frequency turnarounds.",
    primaryLabel: "Contact Us",
    primaryHref: "/get-in-touch#contact-us",
    secondaryLabel: "View Specifications",
    secondaryHref: "#specs",
  },
];

const AUTOPLAY_MS = 2500;

export default function Hero() {
  const [activeIndex, setActiveIndex] = useState(0);
  const slide = BANNER_SLIDES[activeIndex];

  const goTo = useCallback((index) => {
    setActiveIndex((index + BANNER_SLIDES.length) % BANNER_SLIDES.length);
  }, []);

  const goNext = useCallback(() => goTo(activeIndex + 1), [activeIndex, goTo]);

  useEffect(() => {
    if (BANNER_SLIDES.length <= 1) return;
    const timer = setInterval(goNext, AUTOPLAY_MS);
    return () => clearInterval(timer);
  }, [goNext]);

  return (
    <section className="hero-banner md:mt-[112px] lg:mt-[130px] mt-[90px]" id="hero">
      {BANNER_SLIDES.map((s, index) => (
        <div
          key={index}
          className="hero-slide"
          data-active={index === activeIndex}
          aria-hidden={index !== activeIndex}
          style={{
            '--mobile-bg': `url('${s.mobile}')`,
            '--tablet-bg': `url('${s.tablet}')`,
            '--desktop-bg': `url('${s.desktop}')`,
            backgroundImage: `url('${s.desktop}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      ))}

      <div className="hero-content">
        <h1 className="banner-title h3">
          {slide.title[0]}
          <span className="pl-3">{slide.title[1]}</span>
        </h1>
        <div className="banner-actions pb-3">
          <a href={slide.secondaryHref} className="btn-outline-hero btn-with-arrow ">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
            {slide.secondaryLabel}
          </a>
          <a href={slide.primaryHref} className="btn-outline-hero">
            {slide.primaryLabel}
          </a>
        </div>
      </div>

      {BANNER_SLIDES.length > 1 && (
        <div className="hero-dots">
          {BANNER_SLIDES.map((_, index) => (
            <button
              key={index}
              className={`hero-dot ${index === activeIndex ? "active" : ""}`}
              onClick={() => goTo(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}
      <style>
        {`
          @media (max-width: 767px) {
            .levdc .hero-slide {
              background-image: var(--mobile-bg) !important;
              background-position: center bottom;
              background-size: cover;
            }
          }

          @media (min-width: 768px) and (max-width: 1024px) {
            .levdc .hero-slide {
              background-image: var(--tablet-bg) !important;
              background-position: center center;
              background-size: cover;
            }
          }

          @media (min-width: 1025px) {
            .levdc .hero-slide {
              background-image: var(--desktop-bg) !important;
              background-position: top center;
              background-size: cover;
            }
          }
        `}
      </style>
    </section>
  );
}